export default "__VITE_ASSET__9edced4d__"